export default {
    index: {
        type: [String, Number],
        default: 0
    },
    cssClass: {
        type: String,
        default: ''
    },
    data: Object,
    transition: {
        type: [String, Object],
        default: 'slide-up'
    },
    modelValue: Boolean,
    overlayTransition: {
        type: [String, Object],
        default: 'fade'
    },
    hideOverlay: {
        type: Boolean,
        default: false
    },
    zIndex: {
        type: [Boolean, String, Number],
        default: 1000
    },
    searchString: {
        default: '',
    }
}